import { useState, useEffect } from 'react'
import { getAgreementWidgetSettingsData } from '../api'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

export const useGetAgreementSettingsOnMount = () => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        const result = await dispatch(getAgreementWidgetSettingsData())

        if (mounted) {
          if (getAgreementWidgetSettingsData.fulfilled.match(result)) {
            setStatus('success')
          } else {
            setStatus('fail')
          }
        }
      } catch {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return status
}
